import { render, staticRenderFns } from "./jcs-table.vue?vue&type=template&id=c948994a&scoped=true&"
import script from "./jcs-table.vue?vue&type=script&lang=js&"
export * from "./jcs-table.vue?vue&type=script&lang=js&"
import style0 from "./jcs-table.vue?vue&type=style&index=0&id=c948994a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c948994a",
  null
  
)

export default component.exports